import {createFileRoute, useNavigate} from '@tanstack/react-router'
import {Button, Center, Group, LoadingOverlay, Paper, PasswordInput, TextInput, Title} from "@mantine/core";
import {useForm} from "@mantine/form";
import {useLogin} from "@state/server/login.mutation.ts";
import {useUser} from "@state/client/user.store.ts";

export const Route = createFileRoute('/login')({
	component: RouteComponent,
})

function RouteComponent() {
	const form = useForm({
		mode: "uncontrolled",
		initialValues: {
			username: "",
			password: "",
		}
	})

	const {mutateAsync, isPending} = useLogin()
	const navigate = useNavigate()
	const setUser = useUser((state)=>state.onLogin)


	const onLogin = async (values: { username: string, password: string }) => {
		const mutationResult = await mutateAsync(values)
		//@ts-expect-error there isn't typing for this endpoint (for reasons)
		setUser(mutationResult.access_token, values.username)
		navigate({to: "/"})
	}

	return (
		<Center h={"100vh"}>
			<LoadingOverlay visible={isPending} zIndex={1000} overlayProps={{radius: "sm", blur: 2}} />
			<Paper shadow={"xs"} p={"xl"}>
				<Title>Přihlášení</Title>
				<form onSubmit={form.onSubmit((values) => onLogin(values))}>
					<TextInput withAsterisk label={"Uživatel"} placeholder={"uživatel"}
							   key={form.key("username")} {...form.getInputProps("username")}/>
					<PasswordInput withAsterisk label={"Heslo"} placeholder={"heslo"}
								   key={form.key("password")} {...form.getInputProps("password")}/>
					<Group justify="flex-end" mt="md">
						<Button fullWidth type="submit">Přihlásit se</Button>
					</Group>
				</form>
			</Paper>
		</Center>
	)
}
